$(function() {
// Ajax cart
   /* if ($().ajaxKosik) {
        $(".f-add-to-cart__btn").ajaxKosik({
            "loadingText": "loading",
            "loadingClass": "loading"
        });
        $(".f-add-to-cart").ajaxKosik({
            "loadingText": "Loading",
            "loadingClass": "loading",
            "loadingTarget": ".f-add-to-cart__btn"
        });
    }
*/
    console.log("AAAAAAAAAAa");

    $('.f-add-to-cart_btn').closest('form').append('<input type="hidden" name="ajaxeshop" value="1" />');
    $('.f-add-to-cart').append('<input type="hidden" name="ajaxeshop" value="1" />');

});

